import { createBrowserRouter } from 'react-router';
import { RootLayout } from './components/RootLayout';
import { ContactPage } from './pages/Contact';
import { HomePage } from './pages/Home';
import { NotFoundPage } from './pages/NotFound';
import { PrivacyPage } from './pages/Privacy';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: HomePage },
      { path: 'ordina', Component: ContactPage },
      { path: 'privacy', Component: PrivacyPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
